import React from "react";
import styled from "styled-components";
import { Message, MessageList } from "./Messages";
import ParticipateFilter from "./ParticipateFilter";

export default function Messages() {
  const messages = [
    <Message
      key="1"
      text="Hi! We'd like you to participate in shaping your city. Select a category below to see what's close."
    />,
    <Message key="2">
      <ParticipateFilter />
    </Message>
  ];

  return (
    <MessagePosition>
      <MessageList messages={messages} />
    </MessagePosition>
  );
}

const MessagePosition = styled.div`
  position: absolute;
  z-index: 9;
  top: 0px;
  left: 0px;
  margin: ${({ theme }) => theme.spacing(2)}px;
`;
